<template>
    <v-card-text>
        <v-layout row wrap class="pa-0">
            <v-flex md6 xs12>
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.diplomatic_mission_name') + '*'"
                    :rules="[rules.required]"
                    outlined
                    class="pr-3"
                    type="text"
                    v-model="visa.extra.application_data.diplomatic_mission_name"
                />
            </v-flex>
            <v-flex md6 xs12>
                <v-text-field
                    :label="$vuetify.lang.t('$vuetify.position') + '*'"
                    :rules="[rules.required]"
                    outlined
                    class="pr-3"
                    type="text"
                    v-model="visa.extra.application_data.position"
                />
            </v-flex>
        </v-layout>
    </v-card-text>
</template>

<script>
    import {validationMixin} from "../../../mixins/validationMixin";

    export default {
        data: () => ({
            options: [
                {
                    text: "Nepal",
                    value: "Nepal"
                },
                {
                    text: "Abroad",
                    value: "Abroad"
                }
            ]
        }),
        mixins: [validationMixin],

        computed: {
            visa() {
                return this.$store.state.VisaSingle.visa;
            },
            dynamicName() {
                const place = this.visa.extra.application_data.place_staying === "Hotel"
                    ? this.$vuetify.lang.t("$vuetify.hotel")
                    : this.$vuetify.lang.t("$vuetify.place");
                return "Name of the " + place;
            }
        }
    };
</script>

